// utility functions
if (!Util) {
  function Util() {}
}

Util.hasClass = function (el, className) {
  return el.classList.contains(className);
};

Util.addClass = function (el, className) {
  var classList = className.split(" ");
  el.classList.add(classList[0]);
  if (classList.length > 1) Util.addClass(el, classList.slice(1).join(" "));
};

Util.removeNode = function (node) {
  while (node.firstChild) {
    node.removeChild(node.firstChild);
  }

  node.remove();
};

Util.removeClass = function (el, className) {
  var classList = className.split(" ");
  el.classList.remove(classList[0]);
  if (classList.length > 1) Util.removeClass(el, classList.slice(1).join(" "));
};

Util.moveFocus = function (element) {
  if (!element) element = document.getElementsByTagName("body")[0];
  element.focus();

  if (document.activeElement !== element) {
    element.setAttribute("tabindex", "-1");
    element.focus();
  }
}; // File#: _1_drawer
// Usage: codyhouse.co/license

(function () {
  var Drawer = function (element) {
    this.element = element;
    this.content = document.getElementsByClassName("js-drawer__body")[0];
    this.triggers = document.querySelectorAll(
      '[aria-controls="' + this.element.getAttribute("id") + '"]'
    );
    this.firstFocusable = null;
    this.lastFocusable = null;
    this.selectedTrigger = null;
    this.isModal = Util.hasClass(this.element, "js-drawer--modal");
    this.showClass = "drawer--is-visible";
    this.preventScrollEl = this.getPreventScrollEl();
    this.initDrawer();
  };

  Drawer.prototype.getPreventScrollEl = function () {
    var scrollEl = false;
    var querySelector = this.element.querySelector('.drawer__line-item-list');
    if (querySelector) scrollEl = querySelector;
    return scrollEl;
  };

  Drawer.prototype.initDrawer = function () {
    var _this = this; //open drawer when custom event product:added is fired

    document.addEventListener("product:added", function () {
      _this.showDrawer();
      _this.initDrawerEvents();
    }); //open drawer when clicking on trigger buttons

    if (this.triggers) {
      for (var i = 0; i < this.triggers.length; i++) {
        this.triggers[i].addEventListener("click", function (event) {
          event.preventDefault();

          if (Util.hasClass(_this.element, _this.showClass)) {
            _this.closeDrawer(event.target);

            return;
          }

          _this.selectedTrigger = event.target;

          _this.showDrawer();

          _this.initDrawerEvents();
        });
      }
    } // if drawer is already open -> we should initialize the drawer events

    if (Util.hasClass(this.element, this.showClass)) this.initDrawerEvents();
  };

  Drawer.prototype.showDrawer = function () {
    var _this = this;

    this.content.scrollTop = 0;
    Util.addClass(this.element, this.showClass);
    this.getFocusableElements();
    Util.moveFocus(this.element); // wait for the end of transitions before moving focus

    this.element.addEventListener("transitionend", function cb(event) {
      Util.moveFocus(_this.element);

      _this.element.removeEventListener("transitionend", cb);
    });
    this.emitDrawerEvents("drawerIsOpen", this.selectedTrigger); // change the overflow of the preventScrollEl
    if (this.preventScrollEl) {
        scrollLock.disablePageScroll(this.preventScrollEl);
        scrollLock.addScrollableTarget(this.element.querySelector('.js-drawer__body'));
        document.body.style.position = "fixed";
        document.body.style.width = "100%";
    }
  };

  Drawer.prototype.closeDrawer = function (target) {
    Util.removeClass(this.element, this.showClass);
    this.firstFocusable = null;
    this.lastFocusable = null;
    if (this.selectedTrigger) this.selectedTrigger.focus(); //remove listeners

    this.cancelDrawerEvents();
    this.emitDrawerEvents("drawerIsClose", target); // change the overflow of the preventScrollEl
    if (this.preventScrollEl) {
        scrollLock.enablePageScroll(this.preventScrollEl);
        document.body.style.position = "";
        document.body.style.width = "";
    }
  };

  Drawer.prototype.initDrawerEvents = function () {
    //add event listeners
    this.element.addEventListener("keydown", this);
    this.element.addEventListener("click", this);
  };

  Drawer.prototype.cancelDrawerEvents = function () {
    //remove event listeners
    this.element.removeEventListener("keydown", this);
    this.element.removeEventListener("click", this);
  };

  Drawer.prototype.handleEvent = function (event) {
    switch (event.type) {
      case "click": {
        this.initClick(event);
      }

      case "keydown": {
        this.initKeyDown(event);
      }
    }
  };

  Drawer.prototype.initKeyDown = function (event) {
    if (
      (event.keyCode && event.keyCode == 27) ||
      (event.key && event.key == "Escape")
    ) {
      //close drawer window on esc
      this.closeDrawer(false);
    } else if (
      this.isModal &&
      ((event.keyCode && event.keyCode == 9) ||
        (event.key && event.key == "Tab"))
    ) {
      //trap focus inside drawer
      this.trapFocus(event);
    }
  };

  Drawer.prototype.initClick = function (event) {
    //close drawer when clicking on close button or drawer bg layer
    if (
      !event.target.closest(".js-drawer__close") &&
      !Util.hasClass(event.target, "js-drawer")
    )
      return;
    event.preventDefault();
    this.closeDrawer(event.target);
  };

  Drawer.prototype.trapFocus = function (event) {
    if (this.firstFocusable == document.activeElement && event.shiftKey) {
      //on Shift+Tab -> focus last focusable element when focus moves out of drawer
      event.preventDefault();
      this.lastFocusable.focus();
    }

    if (this.lastFocusable == document.activeElement && !event.shiftKey) {
      //on Tab -> focus first focusable element when focus moves out of drawer
      event.preventDefault();
      this.firstFocusable.focus();
    }
  };

  Drawer.prototype.getFocusableElements = function () {
    //get all focusable elements inside the drawer
    var allFocusable = this.element.querySelectorAll(
      '[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable], audio[controls], video[controls], summary'
    );
    this.getFirstVisible(allFocusable);
    this.getLastVisible(allFocusable);
  };

  Drawer.prototype.getFirstVisible = function (elements) {
    //get first visible focusable element inside the drawer
    for (var i = 0; i < elements.length; i++) {
      if (
        elements[i].offsetWidth ||
        elements[i].offsetHeight ||
        elements[i].getClientRects().length
      ) {
        this.firstFocusable = elements[i];
        return true;
      }
    }
  };

  Drawer.prototype.getLastVisible = function (elements) {
    //get last visible focusable element inside the drawer
    for (var i = elements.length - 1; i >= 0; i--) {
      if (
        elements[i].offsetWidth ||
        elements[i].offsetHeight ||
        elements[i].getClientRects().length
      ) {
        this.lastFocusable = elements[i];
        return true;
      }
    }
  };

  Drawer.prototype.emitDrawerEvents = function (eventName, target) {
    var event = new CustomEvent(eventName, {
      detail: target
    });
    this.element.dispatchEvent(event);
  };

  window.Drawer = Drawer; //initialize the Drawer objects

  var drawer = document.getElementsByClassName("js-drawer");

  if (drawer.length > 0) {
    for (var i = 0; i < drawer.length; i++) {
      (function (i) {
        new Drawer(drawer[i]);
      })(i);
    }
  }
})();

(function () {
  var CartItem = function (element, data) {
    if(!element && data) {
        this.element = document.createElement('div');
        Util.addClass(this.element, 'drawer__line-item');
        this.element.dataset.lineItem = data.id;
        this.element.innerHTML = this.buildItem(data)
    } else {
        this.element = element;
    }

    this.id = this.element.dataset.lineItem;
    this.price = this.element.querySelector('.drawer__product-price').dataset.priceTag;
    this.quantity = this.element.querySelector(".quantity-selector__value");
    this.decreaseQuantitySelector = this.element.querySelector('[data-action="decrease-quantity"]');
    this.increaseQuantitySelector = this.element.querySelector('[data-action="increase-quantity"]');
    this.loadingSpinner = this.element.querySelector(".spinner-wrapper");
    this.initCartItem();
  };

  CartItem.prototype.buildItem = function (data) {
    const product =
    `<div class="drawer__image-wrapper">
        <img width="90" height="90" class="drawer__line-item-image" loading="lazy" src="${data.featured_image?.url || data.featured_image?.src || data.featured_image}" alt="${data.featured_image.alt || "" }">
    </div>
    <div class="drawer__item-wrapper">
        <a href="" class="drawer__product-title">${data.name || data.title}</a>
        <p class="price price--highlight drawer__product-price" data-price-tag="${data.price}">${Currency.formatMoney(data.price, window.theme.moneyFormat)}</p>
        
        <div class="drawer__item--edit-quantity">
            <div class="quantity-selector">
                <button class="quantity-selector__button" data-action="decrease-quantity" aria-label=" title="">
                    <svg focusable="false" class="icon icon--minus " viewBox="0 0 10 2" role="presentation">
                        <path d="M10 0v2H0V0z" fill="currentColor"></path>
                    </svg>
                </button>
                <p class="quantity-selector__value">${data.quantity}</p>
                <button class="quantity-selector__button" data-action="increase-quantity" aria-label="" title="">
                <svg focusable="false" class="icon icon--plus " viewBox="0 0 10 10" role="presentation">
                    <path d="M6 4h4v2H6v4H4V6H0V4h4V0h2v4z" fill="currentColor" fill-rule="evenodd"></path>
                </svg>
                </button>
            </div>
            <button data-action="remove-product" data-quantity="0" data-id="" class="link">${window.languages.productRemoved}</button>
        </div>
    </div>

    <div class="spinner-wrapper">
        <div class="spinner"></div>
    </div>`;
    return product;
}

  CartItem.prototype.initCartItem = function () {
    this.element.addEventListener("click", this.handleClick.bind(this));
  };

  CartItem.prototype.handleClick = function (event) {
    switch (event.target.getAttribute("data-action")) {
      case "decrease-quantity": {
        this.updateQuantity(event, -1);
        return;
      }

      case "increase-quantity": {
        this.updateQuantity(event, 1);
        return;
      }
      case "remove-product": {
        this.updateQuantity(event, parseInt(-this.quantity.innerHTML));
      }
    }
  };

  CartItem.prototype.toggleLoading = function (remove) {
    var _this = this;
    if (remove) {
      Util.addClass(this.element, "deleted");
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('cart:removeProduct', {
            detail: {
                id: _this.id,
            }
        }));
        Util.removeNode(this.element);
      }, "500");
    }

    Util.hasClass(this.loadingSpinner, "active")
      ? Util.removeClass(this.loadingSpinner, "active")
      : Util.addClass(this.loadingSpinner, "active");
  };

  CartItem.prototype.updateFetch = async function (event, quantity) {
    var _this = this;
    return await fetch("".concat(window.routes.cartChangeUrl, ".js"), {
      body: JSON.stringify({
        id: _this.id,
        quantity: quantity
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    }).then((res) => {
        return res;
    })
  };

  CartItem.prototype.updateQuantityUI = function(adjustQuantity) {
    this.quantity.innerHTML = `${parseInt(this.quantity.innerHTML) + parseInt(adjustQuantity)}`;
  }

  CartItem.prototype.updateQuantity = function (event, adjustQuantity) {
    var _this = this;

    this.toggleLoading();
    const oldQuantity = parseInt(this.quantity.innerHTML);
    const newQuantity = oldQuantity + adjustQuantity;

    this.updateFetch(event, newQuantity).then(function (res) {
        newQuantity <= 0 ? _this.toggleLoading(true) : _this.toggleLoading();
        if(res.ok) {
            _this.updateQuantityUI(adjustQuantity);
            document.dispatchEvent(new CustomEvent('cart:productUpdated', {}));
        }
    })
  };

  var Cart = function () {
    this.cartElement = document.querySelector(".js-drawer");
    this.cartItems = [];
    this.totalAmount = this.cartElement.querySelector('.drawer__footer-total-price-tag');
    this.itemsList = this.cartElement.querySelector('.drawer__line-item-list');
    this.lineItems = document.querySelectorAll("[data-line-item]");
    this.hidden = "hidden";
    this.initCart();
  };

  Cart.prototype.initCart = function () {
      this.initCartItems();
      this.initHandleTerms();
  };

  Cart.prototype.initCartItems = function () {
    var _this = this;
    this.cartElement.querySelectorAll("[data-line-item]").forEach((item) => {
        _this.cartItems.push(new CartItem(item, null));
      });

    document.addEventListener('cart:removeProduct', this.removeProduct.bind(this));
    document.addEventListener('product:added', this.addProduct.bind(this));
    document.addEventListener('cart:productUpdated', this.updateTotalPrice.bind(this));
  };

  Cart.prototype.createData = async function(event) {
    const { variant, quantity } = event.detail;
    if (variant !== null && typeof variant === 'object' && typeof variant.then === 'function' && typeof variant.catch === 'function') {
        const data = await variant;
        return {
            ...data,
            "quantity": `${quantity}`
        }; // add from collectionpage
    } else {
        return  {
            ...variant,
            "quantity": `${quantity}`
        }; // add from pdp & upsale
    }
  } 

  Cart.prototype.updateCartQuantity = function(CartItemCount) {
    const headerCartIcon = document.querySelector('.header__cart-count');
    const drawerItemCount = this.cartElement.querySelector('.js-item-count');
    drawerItemCount.innerHTML = `(${CartItemCount})`;
    headerCartIcon.innerHTML = CartItemCount;
  }

  Cart.prototype.updateTotalPrice = function() {
    var price = 0;
    var totalCartLineItems = 0;
    this.cartItems.forEach((item) => {
        const itemCount = parseInt(item.quantity.innerHTML)
        price += (parseInt(item.price) * itemCount);
        totalCartLineItems += 1 * itemCount;
    })
    this.totalAmount.innerHTML = Currency.formatMoney(price, window.theme.moneyFormat)
    this.updateCartQuantity(totalCartLineItems);
  }
  
  Cart.prototype.removeProduct = function(event) {
    const id = event.detail.id;
    const tempArr = this.cartItems.filter(function(item, index) {
        return item.id !== id;
    })
    this.cartItems = tempArr;
    this.updateTotalPrice();
  }

  Cart.prototype.addProduct = function(event) {
    var _this = this;
    const quantity = event.detail.quantity;

    this.createData(event).then((data) => {
        if(!_this.cartItems.length) {
            const cartItem = new CartItem(null, data);
            _this.itemsList.insertAdjacentElement('afterbegin', cartItem.element);
            _this.cartItems.push(cartItem);
            this.updateTotalPrice();
            return;
        } // if there is nothing in the cart and something is added
        
        const index = _this.cartItems.findIndex((item) => data.id == item.id);
        if(index !== -1) {
            _this.cartItems[index].updateQuantityUI(quantity);
            this.updateTotalPrice();
            return;
        } // if product exist in cart already
        
        // Add product to cart if not exist
        const cartItem = new CartItem(null, data);
        this.itemsList.insertAdjacentElement('afterbegin', cartItem.element);
        this.cartItems.push(cartItem);
        this.updateTotalPrice();
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
    });
  }

  Cart.prototype.initHandleTerms = function () {
    const form = this.cartElement.querySelector("form");
    const checkoutCheckbox = this.cartElement.querySelector(
      '[name="checkout-checkbox"]'
    );
    const goToCheckoutBtn = this.cartElement.querySelector(".js-goto-checkout");
    const popUpEle = this.cartElement.querySelector(".drawer__pop-up");
    const popUpClose = popUpEle.querySelector(".drawer__pop-up-close");
    popUpClose.addEventListener("click", () => {
      this.togglePopUp(popUpEle);
    });
    form.addEventListener("submit", (e) => {
            if (checkoutCheckbox && !checkoutCheckbox.checked) {
        this.togglePopUp(popUpEle);
        e.preventDefault();
        return false;
      }
    });
    goToCheckoutBtn.addEventListener("click", () => {
      window.location.href = "/checkout";
    });
  };

  Cart.prototype.togglePopUp = function (element) {
    if (Util.hasClass(element, this.hidden)) {
      Util.removeClass(element, this.hidden);
    } else {
      Util.addClass(element, this.hidden);
    }
  };

  new Cart();
})();
